// @ts-nocheck
import PropTypes from "prop-types";

const CustomSteps = ({steps, current}) => (
  <div style={{display: "flex", justifyContent: "center", alignItems: "center", gap: 32, marginBottom: 24}}>
    {steps.map((step, idx) => {
      const isActive = idx === current;
      const isDone = idx < current;
      const isDimmed = idx > current;

      return (
        <div
          key={step.title}
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 0,
            opacity: isDimmed ? 0.45 : 1,
            transition: "opacity 0.2s",
          }}
        >
          {/* Number circle */}
          <div
            style={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 700,
              fontSize: 15,
              background: isActive
                ? "var(--color-lottery)"
                : isDone
                  ? "rgba(255,3,96,0.2)"
                  : "rgba(255,255,255,0.08)",
              color: isActive ? "#fff" : isDone ? "var(--color-lottery)" : "rgba(255,255,255,0.6)",
              transition: "background 0.2s, color 0.2s",
              flexShrink: 0,
            }}
          >
            {idx + 1}
          </div>

          {/* Label */}
          <div style={{position: "relative", paddingLeft: 8, paddingBottom: 4}}>
            <span
              style={{
                fontWeight: isActive ? 700 : 500,
                fontSize: 14,
                color: isActive ? "#fff" : isDone ? "var(--color-lottery)" : "rgba(255,255,255,0.55)",
                whiteSpace: "nowrap",
                transition: "color 0.2s",
              }}
            >
              {step.title}
            </span>
            {/* Active underline — pink gradient */}
            {isActive && (
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 8,
                  right: 0,
                  height: 2,
                  borderRadius: 2,
                  background: "var(--color-lottery)",
                }}
              />
            )}
          </div>
        </div>
      );
    })}
  </div>
);

CustomSteps.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  current: PropTypes.number.isRequired,
};

export default CustomSteps;

